import { Ball, Misc, OvalShading, Player, RectangleShading, TextBox, TrapezoidShading } from "../marker";

export enum SoccerMiscType {
  BALL_STATIC = "BALL_STATIC",
  GOAL = "GOAL",
  FLAG = "FLAG",
  CONE = "CONE",
  LADDER = "LADDER",
}

export type SoccerMiscMarker = Misc<SoccerMiscType>;

export type SoccerMarker =
  | Player
  | Ball
  | TextBox
  | SoccerMiscMarker
  | RectangleShading
  | OvalShading
  | TrapezoidShading;
